// Module
var code = "&nbsp; ";
// Exports
export default code;